import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';

import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Footer 组件
 */
class FocusList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    listH3View = data => {
        const h3info = [];

        h3info.push(
            <h3 className={styles.second_title}>
                <a href={data?.url} title={data?.title2 ? data?.title2 : data?.title} target="_blank" rel="noreferrer">
                    {data?.title2 ? data?.title2 : data?.title}
                </a>
            </h3>,
        );

        return h3info;
    };

    listDivView = data => {
        const element = [];

        for (let i = 0; i < data.length; i++) {
            element.push(
                <div className={styles.topNews} key={i}>
                    {this.listH3View(data[i])}
                </div>,
            );
        }

        return element;
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return <div className={styles.leftContent}>{this.listDivView(content)}</div>;
    }
}

export default errorBoundary(FocusList);
